import { serverUrl, getheader, setErrorDialog } from "../../../store/api/CommonFunctions";
export function attachFile(fileInput, parentID, attachmentType, fn, moreInfo, nameIsUnique) {
    if (!fileInput || !fileInput.files || fileInput.files.length === 0) {
        if (fn) {
            fn();
        }
        return;
    }
    var formdata = new FormData();
    for (let i = 0; i < fileInput.files.length; i++) {
        formdata.append(fileInput.files[i].name, fileInput.files[i]);
        formdata.append("ParentID", parentID);
        formdata.append("AttachmentType", attachmentType);
    }
    if (moreInfo) {
        formdata.append("moreInfo", moreInfo);
    }
    var xhr = new XMLHttpRequest();
    xhr.open('POST', serverUrl + 'api/Attachments/Upload', true);
    xhr.setRequestHeader("token", localStorage.getItem("token"));
    if (nameIsUnique) {
        xhr.setRequestHeader("NameIsUniq", nameIsUnique);
    }
    xhr.send(formdata);
    xhr.onreadystatechange = function () {
        if (xhr.readyState === 4 && xhr.status === 200) {
            var response = JSON.parse(xhr.responseText);
            if (response.Message !== "Error") {
                alert("بارگذاری با موفقیت انجام شد");
                if (fn)
                    fn();
            }
            else {
                alert("اشکال در آپلود فایل");
            }

        }
        return "UnExpected Error";

    };
}
export function downloadFile(itemID, attachmentType) {
    // window.open(serverUrl + `api/Attachments/DownloadAttachment?id=${itemID}&attachmentType=${attachmentType}`, "download");
    fetch(serverUrl + `api/Attachments/DownloadAttachment?id=${itemID}&attachmentType=${attachmentType}`,
        {
            headers: {
                'Content-Type': 'blob',
                'token': localStorage.getItem("token")
            }
            , method: "get"
        })
        .then((response) => {
            response.blob()
                .then((blob) => {
                    if (blob.type === "application/json") {
                        return;
                    }
                    var a = document.createElement("a");
                    a.href = window.URL.createObjectURL(blob);
                    a.download = "Download";
                    a.click();
                })
        })
}
export function deleteAttachment(id, type, onSuccess) {
    return dispatch => {
        fetch(serverUrl + `api/Attachments/DeleteAttachment?id=${id}&attachmentType=${type}`, {
            headers: getheader(),
            method: "GET",
            cache: "no-cache"
        }).then(res => res.json())
            .then(res => {
                if (res === "Success") {
                    setErrorDialog(dispatch, "success", "حذف پیوست");
                    if (onSuccess) {
                        onSuccess();
                    }
                }
                else {
                    setErrorDialog(dispatch, "Error", "حذف پیوست");
                    return dispatch({
                        type: "DELETE_ATTACHMENT",
                        data: "ERROR"
                    });
                }
            }).catch(e => {
                console.log("[DELETE_ATTACHMENT]", e);
            })
    }
}
export function loadDocumentTypes(onGetData) {
    onGetData("PENDING");
    fetch(serverUrl + "api/DocumentsAPI/GetDocumentTypes", {
        headers: getheader(),
        method: "GET",
        cache: "no-cache"
    }).then(res => res.json())
        .then(res => {
            if (res.Message) {
                res = [];
            }
            onGetData(res);
        }).catch(e => { onGetData([]); console.log("DOCUMENT_TYPES", e); })
}
export function setMapLabels(mapRef) {
    if (!mapRef.current) {
        return;
    }
    mapRef.current.querySelectorAll("svg path").forEach(path => {
        const name = path.getAttribute("code");
        const polygon = pathToPolygon(path, 1); // نمونه‌گیری هر 1px
        const [x, y] = window.polylabel(polygon, 1);

        const area = polygonArea(polygon);

        // تعیین اندازه فونت بر اساس مساحت (مقیاس تجربی)
        let fontSize = Math.max(3, Math.min(6, Math.sqrt(area) / 2));
        // اگر استان خیلی کوچک است کمی متن را بالا ببریم
        const offsetY = (area < 15) ? -1.5 : 0;

        const text = document.createElementNS("http://www.w3.org/2000/svg", "text");
        text.setAttribute("x", x);
        text.setAttribute("y", y + offsetY);
        text.setAttribute("font-size", fontSize);
        text.setAttribute("text-anchor", "middle");
        text.setAttribute("dominant-baseline", "middle");
        text.setAttribute("fill", "#111");
        text.setAttribute("stroke", "#fff");
        text.setAttribute("stroke-width", "2px");
        text.setAttribute("paint-order", "stroke");
        text.textContent = name;
        path.appendChild(text);
    });
}
    function pathToPolygon(path, step = 1) {
        const length = path.getTotalLength();
        const points = [];
        for (let d = 0; d <= length; d += step) {
            const pt = path.getPointAtLength(d);
            points.push([pt.x, pt.y]);
        }
        return [points]; // polylabel expects array of rings
    }

    // تابع برای محاسبه مساحت تقریبی polygon
    function polygonArea(points) {
        let area = 0;
        const pts = points[0];
        for (let i = 0, len = pts.length; i < len; i++) {
            const [x1, y1] = pts[i];
            const [x2, y2] = pts[(i + 1) % len];
            area += (x1 * y2 - x2 * y1);
        }
        return Math.abs(area / 2);
    }